import Component from "inferno-component";
import ReactGA from "react-ga";
import { animateOnAdd, animateOnRemove } from "inferno-animation";
import "./Page.css";


export default class Page extends Component {
   componentDidMount() {
      animateOnAdd( this, "PageAnimation", ( el ) => {
         // Element 'el' is now visible
         document.getElementsByTagName( "main" )[0].scrollTop = 0;
      } );

      ReactGA.pageview( window.location.pathname + window.location.search );
   }


   componentWillUnmount() {
      animateOnRemove( this, "PageAnimation", ( el ) => {
         // Element 'el' will be removed when this callback has returned
      } )
   }
}



// WEBPACK FOOTER //
// ./src/Page.js